import React from "react";
import {
  FD_VOTE_CTA,
  FD_VOTE_HINT,
  fdPickCountLabel,
  fdVoteSignalHint,
} from "../copy.js";
import DemoStickyBar from "../../../components/demo/DemoStickyBar";
import { ReadableNavButton } from "../../../components/Sticker";
import { FieldHint } from "../../../components/createEvent/CreateEventFormUi";
import AttendeeTile from "../components/AttendeeTile.jsx";
import { DEMO_PAGE_PB_STICKY } from "../../../lib/demoRoutes";

export default function PlayStep({
  attendees = [],
  selected = [],
  maxPicks = 3,
  onToggle,
  onSubmit,
  submitting = false,
  footer = true,
  stickyFooter = false,
  submitTestId = "favorite-dances-submit",
  signalMinAppreciations,
}) {
  const atMaxPicks = selected.length >= maxPicks;
  const canSubmit = selected.length > 0 && !submitting;
  const signalHint = fdVoteSignalHint(signalMinAppreciations);

  return (
    <div
      className={`space-y-4 ${stickyFooter ? DEMO_PAGE_PB_STICKY : ""}`}
      data-testid="favorite-dances-vote"
    >
      <FieldHint className="text-[14px] text-ink/75 -mt-1">{FD_VOTE_HINT}</FieldHint>

      <p
        className="font-ui text-[13px] font-medium text-ink/70"
        aria-live="polite"
        data-testid="favorite-dances-pick-count"
      >
        {fdPickCountLabel(selected.length)}
        {atMaxPicks && selected.length > 0 && (
          <span className="text-ink/55"> — tap someone to change a pick</span>
        )}
      </p>

      <div className="grid grid-cols-3 sm:grid-cols-4 gap-3" role="group" aria-label="Checked-in dancers">
        {attendees.map((person) => (
          <AttendeeTile
            key={person.dancer_id}
            person={person}
            selected={selected.includes(person.dancer_id)}
            onToggle={onToggle}
            atMaxPicks={atMaxPicks}
          />
        ))}
      </div>

      {footer && !stickyFooter && (
        <div className="space-y-2 pt-2">
          <ReadableNavButton
            type="button"
            variant="primary"
            className="w-full py-3.5 text-[15px]"
            disabled={!canSubmit}
            onClick={onSubmit}
            data-testid={submitTestId}
          >
            {submitting ? "Sending…" : FD_VOTE_CTA}
          </ReadableNavButton>
          <p className="font-ui text-[13px] text-center text-ink/70 text-pretty" data-testid="favorite-dances-footer">
            {signalHint}
          </p>
        </div>
      )}

      {footer && stickyFooter && (
        <DemoStickyBar testId="demo-vote-submit-sticky">
          <div className="flex-1 space-y-1">
            <ReadableNavButton
              type="button"
              variant="primary"
              className="w-full py-3.5 text-[15px]"
              disabled={!canSubmit}
              onClick={onSubmit}
              data-testid={submitTestId}
            >
              {submitting ? "Sending…" : FD_VOTE_CTA}
            </ReadableNavButton>
            <p className="font-ui text-[13px] text-center text-ink/70 text-pretty" data-testid="favorite-dances-footer">
              {signalHint}
            </p>
          </div>
        </DemoStickyBar>
      )}
    </div>
  );
}
